import { CacheInfoComponent } from "./support/cache_info/cache_info.component";
import { Routes } from "@angular/router";
import { RegDayComponent } from "./user/reg_day/reg_day.component";
import { GroupRefComponent } from "./support/group_ref/group_ref.component";
import { BillingComponent } from "./billing/billing/billing.component";
import { DomainBillingComponent } from "./domains/domain_billing/domain_billing.component";
import { MoneyComponent } from "./billing/money/money.component";
import { ExpiredPaidComponent } from "./billing/expired_paid/expired_paid.component";
import { PublishedSiteComponent } from "./sites/published_site/published_site.component";
import { PaymentStructureComponent } from "./billing/payment_structure/payment_structure.component";
import { DomainActionsComponent } from "./domains/domain_actions/domain_actions.component";
import { WidgetReportComponent } from "./sites/widget/widget.component";
import { TemplateTagComponent } from "./template/template_tag/template_tag.component";
import { PromocodeComponent } from "./billing/promocode/promocode.component";
import { BeforePaidComponent } from "./sites/before_paid/before_paid.component";
import { GeoComponent } from "./billing/geo/geo.component";
import { TailComponent } from "./billing/tail/tail.component";
import { AuthenticatedGuard } from "./auth.guard";
import { NoAccessComponent } from "./noaccess/noaccess.component";
import { NotFoundComponent } from "./notfound/notfound.component";
import { AccessorComponent } from "./support/accessor/accessor.component";
import { IndexComponent } from "./index/index.component";
import { SiteTopComponent } from "./sites/site_top/site_top.component";
import { LoadStatComponent } from "./sites/load_stat/load_stat.component";
import { ReturnComponent } from "./billing/return/return.component";
import { ActivityComponent } from "./user/activity/activity.component";
import { OperationDataComponent } from "./billing/operation_data/operation_data.component";
import { TemplateBillingComponent } from "./billing/template_billing/template_billing.component";
import { TestViewComponent } from "./test/test-view/test-view.component";
import { WidgetSearchComponent } from "./sites/widget_search/widget_search.component";
import { LiveComponent } from "./user/live/live.component";
import { ErrorsComponent } from "./billing/errors/errors.component";
import { FriendComponent } from "./billing/friend/friend.component";
import { ExpiredDomainsComponent } from "./domains/expired-domains/expired-domains.component";
import { ConversionRateComponent } from "./billing/conversion_rate/conversion_rate.component";
import { MailComponent } from "./mails/mail/mail.component";
import { MailsStatusComponent } from "./mails/mail_status/mail_status.component";
import { UserChartsComponent } from "./user/user_charts/user_charts.component";
import { DomainZonesComponent } from "./domains/domain_zones/domain_zones.component";
import { SiteCategoriesComponent } from "./template/site_categories/site_categories.component";
import { BalanceComponent } from "./billing/balance/balance.component";
import { CategoryDynamicsComponent } from "./template/category_dynamics/category_dynamics.component";
import { UberComponent } from "./billing/uber/uber.component";
import { MxComponent } from "./sites/mx/mx.component";
import { ConversionComponent } from "./billing/conversion/conversion.component";
import { SiteSubCategoriesComponent } from "./template/site_sub_categories/site_sub_categories.component";
import { SupportComponent } from "./support/support/support.component";
import { MailerComponent } from "./mails/mailer/mailer.component";
import { PerfomanceComponent } from "./api/perfomance/perfomance.component";
import { ManualComponent } from "./billing/manual/manual.component";
import { AclComponent } from "./user/acl/acl.component";
import { OnesComponent } from "./billing/ones/ones.component";
import { DisableRecurrentComponent } from "./billing/disable-recurrent/disable-recurrent.component";
import { WithdrawalsRecurrentComponent } from "./billing/withdrawals-recurrent/withdrawals-recurrent.component";
import { SignInComponent } from './signIn/sign_in';
import { SendTestComponent } from "./mails/send_test/send_test.component";
import { ConversionSourceComponent } from "./billing/conversion-source/conversion-source.component";
import { PromopultComponent } from "./billing/promopult/promopult.component";
import { SiteActionComponent } from "./sites/action/action.component";
import { ZeroDayComponent } from "./billing/zero_day/zero_day.component";
import { TemplateComponent } from "./template/template/template.component";
var ɵ0 = function () { return import("./admin/admin.module.ngfactory").then(function (mod) { return mod.AdminModuleNgFactory; }); };
//##~
var routes = [
    { path: '', component: IndexComponent, canActivate: [AuthenticatedGuard] },
    { path: 'cache_info', component: CacheInfoComponent, canActivate: [AuthenticatedGuard] },
    { path: 'reg_day', component: RegDayComponent, canActivate: [AuthenticatedGuard] },
    { path: 'domain_billing', component: DomainBillingComponent, canActivate: [AuthenticatedGuard] },
    { path: 'domain_actions', component: DomainActionsComponent, canActivate: [AuthenticatedGuard] },
    { path: 'group_ref', component: GroupRefComponent, canActivate: [AuthenticatedGuard] },
    { path: 'billing', component: BillingComponent, canActivate: [AuthenticatedGuard] },
    { path: 'money', component: MoneyComponent, canActivate: [AuthenticatedGuard] },
    { path: 'template_billing', component: TemplateBillingComponent, canActivate: [AuthenticatedGuard] },
    { path: 'expired_paid', component: ExpiredPaidComponent, canActivate: [AuthenticatedGuard] },
    { path: 'billing/tail', component: TailComponent, canActivate: [AuthenticatedGuard] },
    { path: 'published_site', component: PublishedSiteComponent, canActivate: [AuthenticatedGuard] },
    { path: 'before_paid', component: BeforePaidComponent, canActivate: [AuthenticatedGuard] },
    { path: 'payment_structure', component: PaymentStructureComponent, canActivate: [AuthenticatedGuard] },
    { path: 'widget', component: WidgetReportComponent, canActivate: [AuthenticatedGuard] },
    { path: 'template_tag', component: TemplateTagComponent, canActivate: [AuthenticatedGuard] },
    { path: 'promocode', component: PromocodeComponent, canActivate: [AuthenticatedGuard] },
    { path: 'billing/return', component: ReturnComponent, canActivate: [AuthenticatedGuard] },
    { path: 'operation_data', component: OperationDataComponent, canActivate: [AuthenticatedGuard] },
    { path: 'geo', component: GeoComponent, canActivate: [AuthenticatedGuard] },
    { path: 'accessor', component: AccessorComponent, canActivate: [AuthenticatedGuard] },
    { path: 'site_top', component: SiteTopComponent, canActivate: [AuthenticatedGuard] },
    { path: 'load_stat', component: LoadStatComponent, canActivate: [AuthenticatedGuard] },
    { path: 'activity', component: ActivityComponent, canActivate: [AuthenticatedGuard] },
    { path: 'test_view', component: TestViewComponent, canActivate: [AuthenticatedGuard] },
    { path: 'widget_search', component: WidgetSearchComponent, canActivate: [AuthenticatedGuard] },
    { path: 'user/live', component: LiveComponent, canActivate: [AuthenticatedGuard] },
    { path: 'billing/errors', component: ErrorsComponent, canActivate: [AuthenticatedGuard] },
    { path: 'promocode/friend', component: FriendComponent, canActivate: [AuthenticatedGuard] },
    { path: 'expired_domains', component: ExpiredDomainsComponent, canActivate: [AuthenticatedGuard] },
    { path: 'conversion_rate', component: ConversionRateComponent, canActivate: [AuthenticatedGuard] },
    { path: 'mail', component: MailComponent, canActivate: [AuthenticatedGuard] },
    { path: 'mail_status', component: MailsStatusComponent, canActivate: [AuthenticatedGuard] },
    { path: 'user_charts', component: UserChartsComponent, canActivate: [AuthenticatedGuard] },
    { path: 'domain_zones', component: DomainZonesComponent, canActivate: [AuthenticatedGuard] },
    { path: 'site_categories', component: SiteCategoriesComponent, canActivate: [AuthenticatedGuard] },
    { path: 'site_sub_categories', component: SiteSubCategoriesComponent, canActivate: [AuthenticatedGuard] },
    { path: 'balance', component: BalanceComponent, canActivate: [AuthenticatedGuard] },
    { path: 'category_dynamics', component: CategoryDynamicsComponent, canActivate: [AuthenticatedGuard] },
    { path: 'uber', component: UberComponent, canActivate: [AuthenticatedGuard] },
    { path: 'mx', component: MxComponent, canActivate: [AuthenticatedGuard] },
    { path: 'conversion', component: ConversionComponent, canActivate: [AuthenticatedGuard] },
    { path: 'support', component: SupportComponent, canActivate: [AuthenticatedGuard] },
    { path: 'mailer', component: MailerComponent, canActivate: [AuthenticatedGuard] },
    { path: 'mails/test', component: SendTestComponent, canActivate: [AuthenticatedGuard] },
    { path: 'perfomance', component: PerfomanceComponent, canActivate: [AuthenticatedGuard] },
    { path: 'manual_paid', component: ManualComponent, canActivate: [AuthenticatedGuard] },
    { path: 'user/acl', component: AclComponent, canActivate: [AuthenticatedGuard] },
    { path: 'billing/ones', component: OnesComponent, canActivate: [AuthenticatedGuard] },
    { path: 'billing/disable_recurrent', component: DisableRecurrentComponent, canActivate: [AuthenticatedGuard] },
    { path: 'billing/withdrawals_recurrent', component: WithdrawalsRecurrentComponent, canActivate: [AuthenticatedGuard] },
    { path: 'billing/conversion_source', component: ConversionSourceComponent, canActivate: [AuthenticatedGuard] },
    { path: 'billing/promopult', component: PromopultComponent, canActivate: [AuthenticatedGuard] },
    { path: 'billing/zero_day', component: ZeroDayComponent, canActivate: [AuthenticatedGuard] },
    { path: 'admin', loadChildren: ɵ0, canActivate: [AuthenticatedGuard] },
    { path: 'site/action', component: SiteActionComponent, canActivate: [AuthenticatedGuard] },
    { path: 'template', component: TemplateComponent, canActivate: [AuthenticatedGuard] },
    { path: '403', component: NoAccessComponent },
    { path: '404', component: NotFoundComponent },
    { path: 'sign_in', component: SignInComponent },
    { path: '**', redirectTo: '/404' }
];
//~##
var RoutingModule = /** @class */ (function () {
    function RoutingModule() {
    }
    return RoutingModule;
}());
export { RoutingModule };
export { ɵ0 };
